module.exports = __webpack_public_path__ + "static/NightInTheWoods7-f1c436afa0dcf8b1500f604dd61d6d11.png";